/**
 * NULLRUN renderer entry point.
 *
 * Boots the thin DOM renderer over the pure engine: builds the Store (which
 * loads meta + probes for a resumable run via the SaveManager) and the App
 * router, then mounts into #app. The engine + save logic does all the work;
 * this file only wires them to the page.
 */

import "./renderer/palette.css";
import { Store } from "./renderer/store";
import { App } from "./renderer/app";
import { cardFace } from "./renderer/widgets";
import { allCardIds } from "./engine";

const root = document.getElementById("app");
if (!root) {
  throw new Error("NULLRUN: #app mount point not found");
}

const store = new Store();
// eslint-disable-next-line @typescript-eslint/no-unused-vars
new App(root, store);

// Expose for debugging in the console (read-only convenience; not used by game).
// `renderAllCards` mounts every card face into a hidden node so the verifier can
// measure description fit across the WHOLE set (not just the random ones a run
// happens to show). It's never called by gameplay.
(window as unknown as { __nullrun?: unknown }).__nullrun = {
  store,
  renderAllCards(host: HTMLElement) {
    host.innerHTML = "";
    host.style.display = "flex";
    host.style.flexWrap = "wrap";
    for (const id of allCardIds()) {
      host.appendChild(cardFace(id, { playable: false }));
    }
  },
};
